<template>
  <div class="pb-10">
    <div class="flex flex-wrap">
      <v-toolbar flat color="white" class="elevation-1">
        <div class="px-2">
          <div class="circle_warning"></div>{{ $t("message.LicensesManager.search.statusList.pendingSupervisor") }}
        </div>
        <div class="px-2">
          <div class="circle_info"></div>{{ $t("message.LicensesManager.search.statusList.pendingHr") }}
        </div>
        <div class="px-2">
          <div class="circle_success"></div>{{ $t("message.LicensesManager.search.statusList.approved") }}
        </div>
        <v-spacer></v-spacer>
        <div class="inline-flex w-40 text-zt-lg">
          <zt-button outlined class="mr-2" @click="$emit('change-view')" data-vs-button="changeView">
            <zt-icon name="list-solid" />
          </zt-button>
          <zt-button>
            <zt-icon name="calendar-2" />
          </zt-button>
        </div>
      </v-toolbar>
      <div class="w-full bg-white py-6 pl-2 flex flex-wrap">
        <FullCalendar :options="calendarOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Licenses from '@/apiClient/Licenses'
import moment from 'moment'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es';
import ptLocale from '@fullcalendar/core/locales/pt';

export default {
  components: {
    FullCalendar
  },
  created() {
    this.licenses = new Licenses()
  },
  data() {
    return {
      licenses: Licenses,
    }
  },
  methods: {
    setColor(status) {
      if (status === '5') {
        return '#54CAA6'
      }
      if (status === '4') {
        return '#898DFF'
      } else {
        return '#D39011'
      }
    },
    getEvents(info, successCallback, failureCallback) {
      let start = moment(info.start).format('DD/MM/YYYY')
      let end = moment(info.end).format('DD/MM/YYYY')

      this.licenses.getCalendarLicenses(start, end).then(res => {
        const results = res.data.results.data
        let events = []
        results.forEach(val => {
          events.push({
            title: `${val.nombre} ${val.apellido} (${val.numero_legajo}) - ${val.tipo}`,
            start: moment(val.fecha_desde, 'DD/MM/YYYY hh:mm:ss').format('YYYY-MM-DD'),
            end: moment(val.fecha_hasta, 'DD/MM/YYYY hh:mm:ss').format('YYYY-MM-DD'),
            color: this.setColor(val.id_estado)
          })
        })
        successCallback(events)
      })
    }
  },

  computed: {
    ...mapGetters({
      locale: 'getLocale' 
    }),
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        editable: false,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: ''
        },
        locale: this.locale === 'br' ? ptLocale : esLocale,
        events: (info, successCallback, failureCallback) => {
          this.getEvents(info, successCallback, failureCallback)
        },
      }
    },
  }

  
}
</script>

<style lang="scss" scoped>
@mixin circle() {
  height: 10px;
  width: 10px;
  border-radius: 5px;
  display: inline-block;
  padding-left: 1px;
  margin-right: 6px;
}

.circle_warning {
  @include circle();
  border: 2px solid #D39011;
  background-color: #D39011;
}

.circle_success {
  @include circle();
  border: 2px solid #54CAA6;
  background-color: #54CAA6;
}

.circle_info {
  @include circle();
  border: 2px solid #898DFF;
  background-color: #898DFF;
}

.fc {
  /* the calendar root */
  width: 100%;
  margin: 0 auto;
}

::v-deep {
  .fc .fc-button-primary {
    color: var(--branding-textColor, #fff);
    background-color: var(--branding-primary, var(--v-primary-base));
  }

  .fc .fc-button-primary:disabled {
    color: var(--branding-textColor, #fff);
    background-color: var(--branding-secondary, #898DFF);
  }
}
</style>